import PropTypes from "prop-types"
import PeriodDisplay from "connected-components/dashboard/components/period-display"

export default function PerformanceHeader({ context }) {
  return (
    <PeriodDisplay context={context} />
  )
}

PerformanceHeader.propTypes = {
  context: PropTypes.object.isRequired,
}
